module.exports = __webpack_public_path__ + "static/media/meeting-team.ba4684c0.png";